module.exports = __webpack_public_path__ + "static/hrf-383d21addbfa391f903d590235564cc0.png";